import(/* webpackMode: "eager" */ "/codebuild/output/src2181442193/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/page.tsx");
